<template>
    <div>
        <h3>Set the content accessibility</h3>
        <input-switch-component
            label="Secured access"
            v-model="isSecured"
            ></input-switch-component>
        <checkbox-list-component
            v-model="currentOptions"
            :config="listConfig"
            ></checkbox-list-component>
    </div>
</template>
<script>
import CheckboxListComponent from './CheckboxListComponent';
import InputSwitchComponent from './InputSwitchComponent';

export default {
    data() {
        return this.convertToStateAndOptions(this.value);
    },

    props: ['value', 'label', 'required', 'disabled', 'data', 'config', 'error'],

    components: {
        CheckboxListComponent,
        InputSwitchComponent,
    },

    watch: {
        isSecured(newVal) {
            const scopes = this.getScopes(newVal, this.currentOptions);
            this.$emit('input', scopes)
        },
        currentOptions(newVal) {
            const scopes = this.getScopes(this.isSecured, newVal);
            this.$emit('input', scopes)
        },
    },

    computed: {
        values() {
            return _.get(this.config, 'values', []);
        },

        default() {
            return _.get(this.config, 'default', []);
        },

        noTitle() {
            return _.get(this.config, 'noTitle');
        },

        listConfig() {
            return {
                // default: this.default,
                values: this.values,
                noTitle: this.noTitle,
            }
        }
    },

    methods: {
        convertToStateAndOptions(value) {
            const optionMap = _.chain(value)
                .map((scope) => _.split(scope, '.'))
                .reduce((tmp, [domain, vis]) => {
                    tmp[vis] = _.concat(tmp[vis] || [], [domain]);
                    return tmp;
                }, {})
                .value();

            if (optionMap.private) {
                return {
                    isSecured: true,
                    currentOptions: optionMap.private,
                }
            }

            return {
                isSecured: false,
                currentOptions: optionMap.public || [],
            }
        },

        getScopes(secured, options) {
            let scopes = [];
            if (secured) {
                scopes = _.map(options, (option) => `${option}.private`)
            } else {
                scopes = _.map(options, (option) => `${option}.public`)
            }

            return scopes;
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/ScopeSelectComponent.vue